import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Subscription } from 'rxjs'
import { Loader, useObservable } from '@cicero/ui'
import { SafeEditor } from '../editor'
import { PageDoc, PageSchema, useModel } from '../models'

export function EditorPage() {
  const history = useHistory()
  const Page = useModel(PageSchema)
  const isLoading = useObservable(() => Page.loading$, false, [])
  const { owner_id, page_id } = useParams<any>()
  const [page, setPage] = useState<PageDoc|null>(null)

  // Loads the page, and once we have one listens for any change to the slug in case we need to redirect
  useEffect(() => {
    let entity: PageDoc
    const slug = PageSchema.generatePageSlug(owner_id, page_id)
    const subs: Subscription[] = []
    const loadPage = Page.GET_BY_KEY_VALUE$('slug', slug, { modifier: { comments: true, comment_threads: true, attribute_values: true } })
      .subscribe(p => {
        if (p && !entity) {
          entity = p
          subs.push(entity.get$('slug').subscribe(s => {
            if (slug !== s) { history.push(`/${s}`) }
          }))
        }
        if (p) { document.title = `${p.title} - CC` }
        setPage(p)
      })
    subs.push(loadPage)
    return () => { subs.map(sub => sub.unsubscribe()) }
  }, [owner_id, page_id])

  if (!page) {
    return isLoading ? <Loader /> : <p>Page Not Found</p>
  } else {
    return <SafeEditor page={page} key={page.id} />
  }
}
